import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MappingtypePopupScreenComponent } from './mappingtype-popup-screen/mappingtype-popup-screen.component';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { UserRoutingModule } from '../user-routing/user-routing.module';
import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';
@Component({
    selector: 'app-mappingtype',
    templateUrl: './mappingtype.component.html',
    styleUrls: ['./mappingtype.component.scss'],
    standalone: false
})
export class MappingtypeComponent implements OnInit {
  frameworkComponent
  columnDefs
  defaultColDef
  paginationPageSize
  paginationNumberFormatter
  rowClassRules
  backgroundColor
  gridApi
  lastpage
  currentpage
  nextpage
  nextpageplusone
  totalpages
  pagesize
  components
  buttonColor
  backgroundColorScreen
  getdata
  updatedData: null;
  buttonName: any;
  bootstrapColumn: number;
  backgroundColorButton=""
   buttonIdList = []
  getRowStyle: (params: any) => { backgroundColor: string; };
  importExportTableName = "mappingtypes";
  dnsid:number;
  /*
  Author- Venkata Shyam
  04-04-2025
  For creation of mapping type screen
  modified by Raghottam Joshi on 01-06-25
*/


  constructor(private snackbar:MatSnackBar,private localStorrageSettings:LocalStorageSettingsService,private spinner:NgxUiLoaderService,
    private dialog: MatDialog,private commonService: CommonService,private userRoutingModule: UserRoutingModule,
	   private reportLinkService:ReportlinksserviceService)
   {this.components ={
     buttonRenderer: Actionbutton,
   }}

  ngOnInit(): void {
    	   let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorrageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.columnDefs = [{
      headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
      pinned:'left',
      lockPinned:true,
      cellRendererParams: {
        values:this.buttonIdList,
        edit: this.editIcon.bind(this),
        delete: this.deleteIcon.bind(this),
      }, width: 150
    },
      { headerName: 'Library List Id', headerTooltip: 'Library List Id', tooltipValueGetter: (params) => 'Library List Id : ' + params.value, field: 'mappingTypeId', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Library List Name', headerTooltip: 'Library List Name', tooltipValueGetter: (params) => 'Library List Name : ' + params.value, field: 'mappingTypeName', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Tenant Id', headerTooltip: 'TenantId', tooltipValueGetter: (params) => 'tenantId : ' + params.value, field: 'tenantId', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Created By', headerTooltip: 'Created By', tooltipValueGetter: (params) => 'Created By : ' + params.value, field: 'createdBy', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Created Date', headerTooltip: 'Created Date', tooltipValueGetter: (params) => 'Created Date : ' + params.value, field: 'createdByDateAndTime', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Last Modified By', headerTooltip: 'Last Modified By', tooltipValueGetter: (params) => 'Last Modified By : ' + params.value, field: 'lastmodifiedby', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Last Modified Date', headerTooltip: 'Last Modified Date', tooltipValueGetter: (params) => 'Last Modified Date : ' + params.value, field: 'lastModifiedDateAndTime', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 250,  
        cellStyle: function (params){
          if (params.value == 'Yes'){
            return { color: 'green' };
          } else {
            return { color: 'red' };
          }
        } 
      },
      
    ],

    this.getRowStyle = (params: any) => {
      console.log(params)
      console.log(params.data.status)
      if (params.data.status === 'No') {
        return { backgroundColor: 'rgb(211, 211, 211)' }; // Inline style for deleted rows
      }
      // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
    };

    this.buttonColor = this.localStorrageSettings.getSettings("ColorA")
    this.backgroundColorScreen = this.localStorrageSettings.getSettings("ColorD")
    //this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    const tenantId = localStorage.getItem("dnsName");
  this.dnsid = Number(tenantId);

  }
  
  onBtExport() {
    this.gridApi.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.api.paginationGoToLastPage();
  }
  onGridReady(params){
    this.gridApi = params;
    params.api.setGridOption('rowData', [])
    this.spinner.start()
    var tenantId = localStorage.getItem('dnsName');
     console.log(tenantId)
     this.retrieve(tenantId)
  }

  refreshRun() {
    this.spinner.start();
    this.onGridReady(this.gridApi);
    this.spinner.stop();
  }

  retrieve(tenantId){
    console.log("inside retrival")
    this.commonService.retrieveMappingTypesByTenantId(tenantId).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = null;
        this.gridApi.api.setGridOption('rowData', this.getdata)
      }else{
        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.gridApi.api.setGridOption('rowData', this.getdata)
        this.spinner.stop();
      }
     
    })
  }

   
  openSaveForm(buttonName) {
    this.buttonName = buttonName;
   
    let width = '80%';

    if (this.bootstrapColumn == 1) {

      width = '55%';

    }
    var obj={}
    let dialogRef = this.dialog.open(MappingtypePopupScreenComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '60%',
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
     //  this.retrieveAssignUsersRoleByDnsId();

     if (this.gridApi) {
      this.onGridReady(this.gridApi); // Call onGridReady after the popup closes
  }
    });
    
  }

    editIcon(e) {
      let rowData = e.rowData;
      console.log(e.rowData);
      console.log(e.rowData);
      var obj = e.rowData
      console.log(obj);
      console.log(event);
      if(e.rowData.status === "No"){
        this.snackbar.open("Selected record is already deleted","OK",{duration:5000});
        return;
      }
      let dialogRef = this.dialog.open(MappingtypePopupScreenComponent, {
        panelClass: 'custom-dialog-container-materialFulfilment',
        width: '60%',
        autoFocus: false,
        data: { edata: obj},
        disableClose: true,
      });
  
      dialogRef.afterClosed().subscribe(result=>{
        if (this.gridApi) {
          this.onGridReady(this.gridApi); // Call onGridReady after the popup closes
      }
      })
  
    }

    
  deleteIcon(event) {
    console.log(event);
    if(event.rowData.status === "No"){
      this.snackbar.open("Selected record is already deleted","OK",{duration:5000});
      return;
    }
    if(confirm("Are you sure you want to delete this record?")){
      this.spinner.start();
      this.commonService.deleteMappingtype(event.rowData.mappingTypeId).subscribe(result=>{
        if(result.statusMessage === "Successfully record is deleted"){
          this.snackbar.open(result.statusMessage, "OK",{duration:5000});
        }else{
          this.snackbar.open("Cannot delete selected record", "OK",{duration:5000});
        }
        this.refreshRun();
        this.spinner.stop();
      });
    }
    
  }
   importData() {
       
          console.log("<--- Inside upload Group Template --->")
          let width = "85%";
        let dialogRef = this.dialog.open(ImportJsonComponent, {
            maxWidth: "70vw",
            height: "50%",
            width: width,
          data: { "tablename": this.importExportTableName, "tenantid": this.dnsid },
            disableClose: true,
          });
        
          dialogRef.afterClosed().subscribe((result) => {
            console.log(result);
        console.log("tenantid");
            //this.reportCreationData = result;
        
            //this.vaultObjectService.retrieveobjectgroup();
          });
        
        
      }
      
    
      async exportData() {
        this.snackbar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
        let tenantid = localStorage.getItem("dnsName")
       
    
          try {
            const blob = await this.commonService.downloadJsonFile(this.importExportTableName, this.dnsid+"");
            const link = document.createElement('a');
            const timestamp = new Date().getTime();
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.importExportTableName}_export_${timestamp}.json`;
            link.click();
            window.URL.revokeObjectURL(link.href);
    
          } catch (error) {
            console.error('Error downloading JSON:', error);
          }
        
        
      }

}


